import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';

if (process.env.REACT_APP_DEBUG_GENERAL_INFORMATION === 'true') {
  console.log('=== REACT APP STARTUP ===');
  console.log('React version:', React.version);
  console.log('Environment:', process.env.NODE_ENV);
  console.log('Available environment variables:');
  Object.keys(process.env).filter(key => key.startsWith('REACT_APP_')).forEach(key => {
    console.log(`  ${key}:`, process.env[key]);
  });
  console.log('DOM ready, creating React root...');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
if (process.env.REACT_APP_DEBUG_GENERAL_INFORMATION === 'true') console.log('React root created, rendering App component...');
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
if (process.env.REACT_APP_DEBUG_GENERAL_INFORMATION === 'true') {
  console.log('App component render initiated');
  console.log('=== END REACT APP STARTUP ===');
}
